/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Settings_Theme_DescriptionInputs */



/**
* | output |
* | --- |
* | "Follow your system setting, or pick one." |
*
* @param {Partner_Settings_Theme_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_settings_theme_description = /** @type {((inputs?: Partner_Settings_Theme_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Settings_Theme_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Systemeinstellung übernehmen oder selbst wählen.")
	return /** @type {LocalizedString} */ ("Follow your system setting, or pick one.")
});